import React from "react";
import Lottery from "../../component/lottery/index";

export function LotteryComponent() {
  return <Lottery />;
}
